<template>
  <v-card class="mb-3" style="border-radius: 10px;">
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
          :headers="holidays_headers"
          :items="holidays_list"
          class="elevation-0 mt-2 mb-2 mx-3 light-regular-font"
          :no-data-text="this.admin ? 'Nenhum feriado registrado.' : 'Você não foi autorizado.'"
          hide-actions
        >
          <template v-slot:items="list">
            <!-- <td>{{ list.item.name }}</td> -->
            <td class="text-xs-center">{{ list.item.day }}</td>
            <td class="text-xs-right px-0">
              <div style="display: flex; justify-content: space-around">
                <div style="max-width: 35px">
                  <DeleteModal @onConfirm="deleteHoliday(list.item)">
                    <v-icon small style="cursor: pointer;">delete</v-icon>
                  </DeleteModal>
                </div>
              </div>
            </td>
          </template>
        </v-data-table>
        <details-dialog :addBtn="false" :errors="errors" :dialog="dialog" :record="record" @closeDialog="closeDialog" @resetForm="resetForm" @createHoliday="createHoliday" />
        <v-btn color="#0e9e98de" dark small absolute top right fab v-if="this.admin" @click="setInsertForm">
          <v-icon>add</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>

import utils from "../shared/Utils"
import DeleteModal from "../DeleteModal"
import HolidaysDialog from '../HolidaysDialog.vue'

export default {
  name: 'HolidaysList',
  components: { detailsDialog: HolidaysDialog, DeleteModal },
  props: {
    id: {
      type: Number
    }
  },
  data() {
    return {
      admin: false,
      errors: {},
      state: 'insert',
      dialog: false,
      targetUrl: '',
      holidays_list: [],
      holidays_headers: [
        // { text: this.i18n('Motivo'), value: 'name', align: 'left', sortable: false },
        { text: this.i18n('Data'), value: 'day', align: 'center', sortable: true },
      ],
      record: {
        id: '',
        name: '',
        day: '1970-05-05',
      },
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },

    closeDialog() {
      this.dialog = false
    },

    loadHolidaysList() {
      let successCallback = (response) => {
        if (response.body.data) {
          this.holidays_list = response.body.data
        } else {
          console.log(response)
        }
      }

      let errorCallback = (response) => {
        console.log(response)
      }

      const token = this.$cookies.get('api_token')

      this.$http.get(this.$root.urls.admin__holidays, { headers: { Authorization: `Bearer ${token}` }})
        .then(successCallback, errorCallback)
    },

    createHoliday() {
      const token = this.$cookies.get('api_token')
      const payload = { holiday: this.record }
      let successCallback = (response) => {
        if (response.body.data) {
          this.loadHolidaysList()
        } else {
          console.log(response)
        }
        this.dialog = false
        this.resetForm()
      }

      let errorCallback = (response) => {
        if (response.body.errors) {
          let errors = utils.translateErrors(response.body.errors, this.$root.lang)
          this.$set(this, 'errors', errors)
        }
      }
      this.$http.post(
        this.$root.urls.admin__holidays,
        payload,
        { headers: { Authorization: `Bearer ${token}` }}
      ).then(successCallback, errorCallback)

      this.errors = {}
    },

    setInsertForm() {
      this.resetForm()
      this.dialog = true
    },

    resetForm() {
      this.record = {
        name: '',
        day: '',
      },
      this.errors = {}
      this.state = 'insert'
    },

    deleteHoliday(holiday) {
      let successCallback = (response) => {
        this.loadHolidaysList()
        this.$emit('onAccountDelete', holiday)
      }

      let errorCallback = (response) => {
        console.log('errorCallback', response)
      }

      const token = this.$cookies.get('api_token')

      this.$http.delete(
        `${this.$root.urls.admin__holidays}/${holiday.id}`,
        { headers: { Authorization: `Bearer ${token}` }}
      ).then(successCallback, errorCallback)
    }
  },
  mounted() {
    this.admin = this.$cookies.isKey('admin') && this.$cookies.get('admin') === 'true'
    this.loadHolidaysList()
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/HolidaysList.vue